// extracted by mini-css-extract-plugin
export var blue = "_e-h";
export var brand = "_e-d";
export var darkGrey = "_e-g";
export var disabled = "_e-6";
export var disabledSubtle = "_e-7";
export var error = "_e-8";
export var green = "_e-i";
export var grey = "_e-f";
export var icon = "_e-0";
export var inherit = "_e-c";
export var lightGrey = "_e-e";
export var orange = "_e-k";
export var pink = "_e-m";
export var primary = "_e-1";
export var purple = "_e-n";
export var quaternary = "_e-4";
export var quinary = "_e-5";
export var red = "_e-l";
export var secondary = "_e-2";
export var success = "_e-b";
export var tertiary = "_e-3";
export var warning = "_e-9";
export var warningSecondary = "_e-a";
export var white = "_e-o";
export var yellow = "_e-j";